// extracted by mini-css-extract-plugin
export const loadingWrapper = "DismissButton__loadingWrapper__xOizV";